'use strict';

const tuple = (...args) => args;
const tupleNum = (...args) => args;

exports.tuple = tuple;
exports.tupleNum = tupleNum;
//# sourceMappingURL=types.js.map
